// Updated unitApi.ts - Fix for form data handling
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const unitApi = createApi({
  reducerPath: 'unitApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_ENDPOINT,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey', '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Unit'],
  endpoints: (build) => ({
    listUnits: build.query({
      query: () => ({
        url: 'unit/list',
        method: 'POST',
        body: {},
      }),
      providesTags: ['Unit'],
    }),

    addUnit: build.mutation({
      query: (unitData) => ({
        url: 'unit/add',
        method: 'POST',
        body: {
          unit_name: unitData.unit_name,
          unit_short_name: unitData.unit_short_name,
          unit_desc: unitData.unit_desc || '',
        },
      }),
      invalidatesTags: ['Unit'],
    }),

    updateUnit: build.mutation({
      query: (unitData) => ({
        url: 'unit/update',
        method: 'POST',
        body: {
          unit_id: unitData.unit_id,
          unit_name: unitData.unit_name,
          unit_short_name: unitData.unit_short_name,
          unit_desc: unitData.unit_desc || '',
        },
      }),
      invalidatesTags: ['Unit'],
    }),

    deleteUnit: build.mutation({
      query: (unitData) => ({
        url: 'unit/delete',
        method: 'POST',
        body: {
          unit_id: unitData.unit_id,
        },
      }),
      invalidatesTags: ['Unit'],
    }),
  }),
});

export const {
  useListUnitsQuery,
  useAddUnitMutation,
  useUpdateUnitMutation,
  useDeleteUnitMutation,
} = unitApi;